import React from 'react';
import './ViewPassengerPersonalDetails.css';
import {format} from "date-fns";

export default function ViewPassengerPersonalDetails({passenger}){

   
    return(
        <div>
            <div className="passenger-personal-detail-line"><label>First Name:</label> <span>{passenger.firstName}</span></div>
            <div className="passenger-personal-detail-line"><label>Last Name:</label> <span>{passenger.surname}</span></div>
            <div className="passenger-personal-detail-line"><label>DOB:</label> <span>{passenger.dateOfBirth}</span></div>
            <div className="passenger-personal-detail-line"><label>Gender:</label> <span>{passenger.gender}</span></div>
        </div>
    )
}